module.exports = __webpack_public_path__ + "img/unit3-mechanical.8fce7025.svg";